"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.option = void 0;
exports.option = function (axios) {
    return {
        getProductsConfigurableOptions: function (getProductsConfigurableOptions) {
            return axios.get('/products/configurable-options', getProductsConfigurableOptions);
        },
        getProductsConfigurableOptionsV2: function (getProductsConfigurableOptions) {
            return axios.get('/products/configurable-options', getProductsConfigurableOptions);
        },
        getOptionsMallOptionNo: function (getOptionsMallOptionNoRequest) {
            return axios.get("/options/" + getOptionsMallOptionNoRequest.params.mallOptionNo, getOptionsMallOptionNoRequest);
        },
        getProductsMallProductNoOptions: function (getProductsMallProductNoOptionsRequest) {
            return axios.get("/products/" + getProductsMallProductNoOptionsRequest.params.mallProductNo + "/options", getProductsMallProductNoOptionsRequest);
        },
        getProductsMallProductNoOptionsPurchasePrice: function (request) {
            return axios.get("/products/" + request.params.mallProductNo + "/options/purchase-price");
        },
        getProductsMallProductNoOptionsExcel: function (request) {
            return axios.get("/products/" + request.params.mallProductNo + "/options/excel", { responseType: 'blob' });
        }
    };
};
